import Vue from 'vue'
import { MainRequests } from '@/services/main.requests'
const mainService = new MainRequests()
const moment = require('moment')

const state = {
  edited: {
    checkout: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZZ'),
    guests: [
      { name: null, lastName: null, identifier: null }
    ]
  }
}

const getters = {}

const actions = {
  completeForm ({ commit }) {
    return new Promise((resolve, reject) => {
      mainService.save(state.edited).then(() => {
        commit('resetEdited')
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
    }
    Vue.set(state.edited, field, value)
  },
  addGuest (state, guest) {
    state.edited.guests.push(guest)
  },
  editGuest (state, { index, guest }) {
    var updatedGuest = state.edited.guests[index]
    Object.keys(updatedGuest).forEach(key => {
      if (guest[key]) {
        updatedGuest[key] = guest[key]
      }
    })
    state.edited.guests[index] = updatedGuest
  },
  removeGuest (state, index) {
    state.edited.guests.splice(index, 1)
  },
  resetEdited (state) {
    state.edited = {
      guests: [
        { name: null, lastName: null, identifier: null }
      ]
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
